import React from "react";

const IconPlus = ({ color = "#e31c19" }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="950.000000pt"
      height="950.000000pt"
      viewBox="0 0 950.000000 950.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(200.000000,750.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M2493 4790 c-93 -19 -183 -93 -225 -185 l-23 -50 -3 -837 -3 -837
-837 -3 -837 -3 -51 -23 c-64 -29 -136 -102 -166 -167 -33 -74 -31 -181 4
-257 31 -66 86 -123 154 -158 l49 -25 842 -3 842 -2 3 -838 3 -837 27 -57 c84
-180 299 -242 465 -133 28 19 66 55 83 80 62 89 60 61 60 963 l0 822 823 0
c900 0 872 -2 960 59 201 138 171 444 -53 550 l-55 26 -837 3 -838 3 -2 837
-3 837 -26 56 c-63 133 -213 209 -356 179z"
        />
      </g>
    </svg>
  );
};

export default IconPlus;
